import React, {useContext} from "react"
import {MappingsContext} from '../context/mappingsContext'

import {IconSettings} from '@salesforce/design-system-react';

import MappingGroupSection from '../components/MappingGroupSection'

const ExpandableSectionList = () => {
  const {selectedSalesforceObjects} = useContext(MappingsContext) 

  const renderList = (selectedSalesforceObjects).map((obj) => 
    <MappingGroupSection salesforceObjectId={obj.id} key={obj.id} />     
  )

  return (
    <IconSettings iconPath="/icons">
      {renderList}
    </IconSettings>
  )
}

export default ExpandableSectionList;

